import { motion } from "framer-motion";

const ListItem = ({ children, index = null }) => {
  return (
    <motion.li
      key={index}
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      {children}
    </motion.li>
  );
};

export default ListItem;
